<div
  class="back-drop"
  (click)="closeBottomSheet()"
  [ngStyle]="{
    background: !show ? 'transparent' : ' rgba(0, 0, 0, 0.4)'
  }"
></div>
<div class="container" [class.show]="show" [class.selcting]="selecting">
  <div class="header">
    <div class="top-handler" (swipedown)="swipe($event.type)">
      <div class="handler"></div>
    </div>
    <p class="bottomsheet-title">{{ title }}</p>
  </div>
  <div class="bottomsheet-body">
    <div *ngIf="!selecting">
      <div class="select-unit" (click)="selectUnit()">
        <p *ngIf="!selectedUnit">واحد را انتخاب کنید...</p>
        <p *ngIf="selectedUnit">{{ selectedUnit.name }}</p>
      </div>
      <div class="input-wrapper">
        <input
          type="tel"
          [(ngModel)]="calorie"
          (input)="chekButtom()"
          placeholder=" مقدار را وارد کنید..."
        />
        <span class="unit">گرم</span>
      </div>
      <div class="buttons">
        <div class="success" (click)="submit()" [ngClass]="{ blue: active }">
          ثبت
        </div>
        <div class="cancel" (click)="closeBottomSheet()" *ngIf="!edditing">
          بستن
        </div>
        <div class="cancel" (click)="remove()" *ngIf="edditing">حذف</div>
      </div>
    </div>
    <div *ngIf="selecting && foodUnitArray" style="padding: 17px">
      <div
        *ngFor="let unit of foodUnitArray"
        (click)="selectUnitItem(unit)"
        class="unit-item"
      >
        {{ unit.name }}
      </div>
    </div>
  </div>
</div>
